// reducer
const initialState = {
    activeSubscription: null,
};

const subscriptionOfferReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_ACTIVE_SUBSCRIPTION":
      return { ...state, activeSubscription: action.payload };

    default:
      return state;
  }
};

export default subscriptionOfferReducer;
